var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideMenu),expression:"hideMenu"}],staticClass:"menu-dropdown",class:_vm.params.value.options && 'cursor-pointer',style:({
      backgroundColor: _vm.statusColor,
      backgroundImage: !_vm.params.value.options && 'none',
    }),on:{"click":function($event){_vm.showMenu = true}}},[_c('p',{staticClass:"m-0"},[_vm._v(" "+_vm._s(_vm.isStatusValid ? _vm.$t(`borrow_return_statuses.${_vm.params.value.name}`) : "-")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }